import { render, staticRenderFns } from "./ResearchPigeanSearch.vue?vue&type=template&id=01672622&scoped=true"
import script from "./ResearchPigeanSearch.vue?vue&type=script&lang=js"
export * from "./ResearchPigeanSearch.vue?vue&type=script&lang=js"
import style0 from "./ResearchPigeanSearch.vue?vue&type=style&index=0&id=01672622&scoped=true&lang=css"
import style1 from "./ResearchPigeanSearch.vue?vue&type=style&index=1&id=01672622&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01672622",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01672622')) {
      api.createRecord('01672622', component.options)
    } else {
      api.reload('01672622', component.options)
    }
    module.hot.accept("./ResearchPigeanSearch.vue?vue&type=template&id=01672622&scoped=true", function () {
      api.rerender('01672622', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchPigeanSearch.vue"
export default component.exports